import { chakra, Flex } from '@chakra-ui/react';
import { motion } from 'framer-motion';

export const grid = chakra(Flex, {
    label: 'loading-grid',
    baseStyle: {
        w: '100%'
    }
});

export const motionBox = motion(grid);
